import React from "react"
import { Button, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { MdSettingsRemote, MdSmartphone } from "react-icons/md";
import css from "./Addons.module.css"
import { useStore } from "store";
import { useTranslation } from "react-i18next";

function Addons() {
    const { i18n } = useTranslation()
    const t = useStore(state => state.translations)
    const powerSupply = useStore(state => state.powerSupply)
    const control = useStore(state => state.control)
    const setControl = useStore(state => state.setControl)
    const setPowerSupply = useStore(state => state.setPowerSupply)
    return (
        <div>
            <Row className="mb-5">
                <Col>
                    <h3 className="mb-3">{t.settings.addons.remote.label[i18n.language]}</h3>
                    <Button className={css.button} outline onClick={() => setControl("manual")} active={control === "manual"}><MdSettingsRemote />{' '}{t.settings.addons.remote.manual[i18n.language]}</Button>
                    <Button className={css.button} outline onClick={() => setControl("app")} active={control === "app"}><MdSmartphone />{' '}{t.settings.addons.remote.mobileApp[i18n.language]}</Button>
                </Col>
            </Row>
            <Row className="mt-5">
                <Col>
                    <Form>
                        <FormGroup>
                            <Label check className={css.checkboxLabel}>
                            <Input type="checkbox" className={css.checkbox} onChange={(e) => setPowerSupply(e.target.checked)} checked={Boolean(powerSupply)} />{'  '}
                                {t.settings.addons.powerSupply[i18n.language]}
                            </Label>
                        </FormGroup>
                    </Form>
                </Col>
            </Row>
        </div>
    );
}

export default Addons;